import React from "react";

function Character({ character }) {
  const visible = character !== "narrateur";

  if (!visible) return <div className="vn-character hidden" />;

  return (
    <div className="vn-character visible">
      {character === "lyra" && (
        <svg
          width="100"
          height="210"
          viewBox="0 0 100 210"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Cape */}
          <path
            d="M30 90 Q14 135 16 200 L34 200 Q32 150 46 120 Q60 150 58 200 L74 200 Q76 135 60 90 Z"
            fill="#1a472a"
            opacity="0.9"
          />
          {/* Corps armure */}
          <rect x="30" y="88" width="32" height="52" rx="4" fill="#2d6a4f" />
          <rect x="30" y="88" width="32" height="8" rx="3" fill="#1a472a" />
          <line
            x1="46"
            y1="96"
            x2="46"
            y2="140"
            stroke="#1a472a"
            strokeWidth="1.5"
          />
          <rect
            x="34"
            y="102"
            width="8"
            height="6"
            rx="1"
            fill="#1a472a"
            opacity="0.7"
          />
          <rect
            x="50"
            y="102"
            width="8"
            height="6"
            rx="1"
            fill="#1a472a"
            opacity="0.7"
          />
          {/* Ceinture */}
          <rect x="30" y="133" width="32" height="7" rx="2" fill="#8b6914" />
          <rect x="43" y="132" width="6" height="9" rx="1" fill="#f7c97e" />
          {/* Cou */}
          <rect x="43" y="82" width="5" height="6" rx="2" fill="#f4c68d" />
          {/* Bras gauche */}
          <path
            d="M30 93 Q17 106 19 128 L26 126 Q24 108 32 97 Z"
            fill="#2d6a4f"
          />
          <rect x="17" y="126" width="9" height="20" rx="3" fill="#f4c68d" />
          {/* Bras droit */}
          <path
            d="M62 93 Q72 106 70 128 L64 126 Q66 108 58 97 Z"
            fill="#2d6a4f"
          />
          <rect x="63" y="120" width="9" height="20" rx="3" fill="#f4c68d" />
          {/* Arc */}
          <path
            d="M68 105 Q84 128 68 152"
            stroke="#8b6914"
            strokeWidth="2.5"
            fill="none"
            strokeLinecap="round"
          />
          <line
            x1="68"
            y1="105"
            x2="68"
            y2="152"
            stroke="#c8a45a"
            strokeWidth="0.8"
            strokeDasharray="2,2"
          />
          <line
            x1="68"
            y1="128"
            x2="50"
            y2="128"
            stroke="#c8a45a"
            strokeWidth="1.2"
          />
          <polygon points="50,125 44,128 50,131" fill="#c8a45a" />
          {/* Jambes */}
          <rect x="32" y="140" width="12" height="52" rx="4" fill="#1a3a2a" />
          <rect x="48" y="140" width="12" height="52" rx="4" fill="#1a3a2a" />
          {/* Bottes */}
          <rect x="30" y="182" width="16" height="18" rx="3" fill="#2c1810" />
          <rect x="46" y="182" width="16" height="18" rx="3" fill="#2c1810" />
          {/* Groupe tête — change le 2ème chiffre pour descendre */}
          <g transform="translate(0, 6)">
            {/* Tête */}
            <ellipse cx="46" cy="62" rx="17" ry="18" fill="#f4c68d" />
            {/* Oreilles elfiques */}
            <path d="M29 57 L22 49 L30 61 Z" fill="#f4c68d" />
            <path d="M63 57 L70 49 L62 61 Z" fill="#f4c68d" />
            {/* Cheveux */}
            <path
              d="M29 49 Q46 33 63 49 L63 57 Q46 41 29 57 Z"
              fill="#c8a45a"
            />
            <path
              d="M29 51 Q24 65 26 75 L30 73 Q28 63 30 53 Z"
              fill="#c8a45a"
            />
            <path
              d="M63 51 Q68 65 66 75 L62 73 Q64 63 62 53 Z"
              fill="#c8a45a"
            />
            {/* Yeux */}
            <ellipse cx="40" cy="62" rx="3.5" ry="3.5" fill="#3a7a5a" />
            <ellipse cx="52" cy="62" rx="3.5" ry="3.5" fill="#3a7a5a" />
            <ellipse cx="40" cy="61" rx="1.8" ry="1.8" fill="#1a3a2a" />
            <ellipse cx="52" cy="61" rx="1.8" ry="1.8" fill="#1a3a2a" />
            {/* Sourire */}
            <path
              d="M41 71 Q46 75 51 71"
              stroke="#c0735a"
              strokeWidth="1.5"
              fill="none"
              strokeLinecap="round"
            />
            {/* Sourcils */}
            <path
              d="M37 56 Q40 54 43 56"
              stroke="#8b6914"
              strokeWidth="1.2"
              fill="none"
            />
            <path
              d="M49 56 Q52 54 55 56"
              stroke="#8b6914"
              strokeWidth="1.2"
              fill="none"
            />
            {/* Diadème */}
            <path
              d="M30 49 Q46 39 62 49"
              stroke="#f7c97e"
              strokeWidth="1.5"
              fill="none"
            />
            <circle cx="46" cy="43" r="2.5" fill="#7eb8f7" />
          </g>
        </svg>
      )}

      {character === "roi" && (
        <svg
          width="100"
          height="210"
          viewBox="0 0 100 210"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Cape royale */}
          <path
            d="M22 75 Q6 125 8 190 L28 190 Q26 145 40 115 Q54 145 52 190 L72 190 Q74 125 58 75 Z"
            fill="#6b1a1a"
            opacity="0.95"
          />
          {/* Fourrure cape */}
          <path d="M22 75 Q10 85 8 100 L14 102 Q16 88 24 80 Z" fill="#e8e0d0" />
          <path
            d="M58 75 Q70 85 72 100 L66 102 Q64 88 56 80 Z"
            fill="#e8e0d0"
          />
          {/* Corps armure */}
          <rect x="24" y="72" width="32" height="55" rx="4" fill="#8b6914" />
          {/* Plastron */}
          <path
            d="M28 75 L52 75 L54 95 L40 100 L26 95 Z"
            fill="#f7c97e"
            opacity="0.3"
          />
          <line
            x1="40"
            y1="75"
            x2="40"
            y2="127"
            stroke="#6b4f0a"
            strokeWidth="1.5"
          />
          {/* Épaulières */}
          <ellipse cx="24" cy="76" rx="8" ry="5" fill="#a07820" />
          <ellipse cx="56" cy="76" rx="8" ry="5" fill="#a07820" />
          {/* Ceinture */}
          <rect x="24" y="120" width="32" height="8" rx="2" fill="#6b1a1a" />
          <rect x="36" y="119" width="8" height="10" rx="1" fill="#f7c97e" />
          {/* Cou */}
          <rect x="36" y="63" width="8" height="10" rx="3" fill="#d4a574" />
          {/* Bras gauche */}
          <path
            d="M24 78 Q11 92 13 118 L20 116 Q18 95 26 83 Z"
            fill="#8b6914"
          />
          <rect x="11" y="116" width="9" height="20" rx="3" fill="#f4c68d" />
          <rect x="10" y="132" width="11" height="8" rx="2" fill="#a07820" />
          {/* Bras droit avec sceptre */}
          <path
            d="M56 78 Q69 92 67 118 L60 116 Q62 95 54 83 Z"
            fill="#8b6914"
          />
          <rect x="60" y="116" width="9" height="20" rx="3" fill="#f4c68d" />
          {/* Sceptre */}
          <line
            x1="72"
            y1="90"
            x2="68"
            y2="150"
            stroke="#f7c97e"
            strokeWidth="2.5"
          />
          <circle cx="72" cy="88" r="5" fill="#f7c97e" />
          <circle cx="72" cy="88" r="3" fill="#7eb8f7" />
          {/* Jambes */}
          <rect x="26" y="127" width="12" height="55" rx="4" fill="#4a1a1a" />
          <rect x="42" y="127" width="12" height="55" rx="4" fill="#4a1a1a" />
          {/* Bottes */}
          <rect x="24" y="172" width="16" height="18" rx="3" fill="#2c1810" />
          <rect x="40" y="172" width="16" height="18" rx="3" fill="#2c1810" />
          <rect
            x="24"
            y="172"
            width="16"
            height="4"
            rx="1"
            fill="#f7c97e"
            opacity="0.4"
          />
          <rect
            x="40"
            y="172"
            width="16"
            height="4"
            rx="1"
            fill="#f7c97e"
            opacity="0.4"
          />
          {/* Tête */}
          <ellipse cx="40" cy="48" rx="17" ry="19" fill="#d4a574" />
          {/* Barbe */}
          <path
            d="M26 56 Q28 70 40 74 Q52 70 54 56 Q48 62 40 64 Q32 62 26 56 Z"
            fill="#c8c0a0"
          />
          {/* Moustache */}
          <path
            d="M32 54 Q40 58 48 54"
            stroke="#a0987a"
            strokeWidth="2"
            fill="none"
          />
          {/* Cheveux gris */}
          <path d="M23 40 Q40 26 57 40 L57 46 Q40 32 23 46 Z" fill="#a0987a" />
          {/* Yeux */}
          <ellipse cx="34" cy="46" rx="3.5" ry="3.5" fill="#5a4020" />
          <ellipse cx="46" cy="46" rx="3.5" ry="3.5" fill="#5a4020" />
          <ellipse cx="34" cy="45" rx="1.8" ry="1.8" fill="#2a1a08" />
          <ellipse cx="46" cy="45" rx="1.8" ry="1.8" fill="#2a1a08" />
          {/* Rides */}
          <path
            d="M28 42 Q31 40 34 42"
            stroke="#b08050"
            strokeWidth="0.8"
            fill="none"
          />
          <path
            d="M46 42 Q49 40 52 42"
            stroke="#b08050"
            strokeWidth="0.8"
            fill="none"
          />
          {/* Couronne */}
          <rect x="24" y="28" width="32" height="10" rx="2" fill="#f7c97e" />
          <polygon points="24,28 28,18 32,28" fill="#f7c97e" />
          <polygon points="36,28 40,16 44,28" fill="#f7c97e" />
          <polygon points="48,28 52,18 56,28" fill="#f7c97e" />
          <circle cx="28" cy="24" r="2" fill="#e63946" />
          <circle cx="40" cy="20" r="2.5" fill="#7eb8f7" />
          <circle cx="52" cy="24" r="2" fill="#2dc653" />
        </svg>
      )}
    </div>
  );
}

export default Character;
